import React, { Component } from 'react';
import { Form, FormGroup, ControlLabel, FormControl, Panel, Radio, Table } from 'react-bootstrap';
import SuggestionTextBox from './SuggestionTextBox.js';
import InfoBox from './InfoBox.js';

class Competitors extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checksum: window.location.hash.substring(1),
            yourOTAInsightNames: [],
            competitors: []
        };
        this.addCompetitorRef = this.addCompetitorRef.bind(this);
        this.updateUsesOtaInsight = this.updateUsesOtaInsight.bind(this);
        this.displayCompetitors = undefined;
    }

    addCompetitorRef(ref) {
        if(ref !== null) { // The use of id below to get the index is "somewhat" ugly, but it at least works for now.
            this.props.addCompetitorRef(ref, parseInt(ref.id, 10));
        }
    }

    updateUsesOtaInsight(e) {
        this.displayCompetitors = e.currentTarget.value === "false";
        this.props.updateUsesOtaInsight(e);
    }

    render() {
        const title = (
            <h3>Competitors</h3>
        );

        let competitorControls = [];
        for(let i = 0; i < this.props.maxCompetitors; i++) {
            let competitor = undefined;
            if(this.props.competitors.length < i) {
                competitor = this.props.competitors[i];
            }

            competitorControls.push(
                <tr>
                    <th style={{verticalAlign: "middle"}}>{"Competitor " + (i+1)}</th>
                    <td>
                        {this.props.useCompetitorSuggestions ?
                            <SuggestionTextBox inputKey={i+1} inputId={i} inputValue={competitor}
                                inputReference={this.addCompetitorRef}
                                minLengthForSearch={this.props.minLengthForCompetitorSearch}
                                searchFrequency={this.props.competitorSearchFrequency}
                                searchDelay={this.props.competitorSearchDelay}
                                getSuggestions={this.props.getCompetitorSuggestions}
                                placeholderText={this.props.competitorPlaceholderText}/> :
                            <FormControl key={i+1} id={i} name="" type="text" value={competitor} inputRef={this.addCompetitorRef} />
                        }
                    </td>
                </tr>
            );
        }

        return (
            <div>
                <Panel header={title}>
                    <div>Atomize will track prices from your competitors to improve the price recommendations</div>
                    <hr/>
                    <Form>
                        <div className="Competitors-choiceContainer">
                            <ControlLabel>Does your hotel have an account at OTA Insight, with Rate Insight enabled?</ControlLabel>
                            <span className="Competitors-choice">
                                <FormControl style={{width: 200, display: 'inline'}} componentClass="select" onChange={this.updateUsesOtaInsight}>
                                    <option disabled selected value>Select option...</option>
                                    <option value="true">Yes</option>
                                    <option value="false">No / Don't know</option>
                                </FormControl>
                            </span>
                        </div>
                        <InfoBox
                            header={"Do I need to have an account with OTA Insight, with Rate Insight enabled?"}
                            text={"No. If you don't have an account with OTA Insight with Rate Insight enabled, all you need to do is to select \"No\" above and to list your competitors in the fields that appear below."}>
                        </InfoBox>
                        {this.displayCompetitors === false &&
                            <div className="alert alert-warning">
                                <span className="glyphicon glyphicon-warning-sign Competitors-warningSign"></span>
                                Selecting this option means that you <b>already</b> have an active&nbsp;
                                <a target="_blank" href="https://www.otainsight.com">OTA Insight</a> subscription, with Rate Insight enabled&nbsp;
                                and that you have access to their <a target="_blank" href="https://app.otainsight.com">app</a>
                            </div>
                        }
                    </Form>
                    {this.displayCompetitors &&
                        <Form>
                            <FormGroup controlId="competitors">
                                <Table striped>
                                    <tbody>
                                        { competitorControls }
                                    </tbody>
                                </Table>
                            </FormGroup>
                        </Form>
                    }
                </Panel>
            </div>
        );
    }
}

export default Competitors;



// WEBPACK FOOTER //
// ./src/components/Competitors.js